import { PRODUCT_SET, PRODUCT_LIST_START } from "../constants/actionTypes";
import { ProductAction, Product } from "../types/product";
import { ProductStateType } from "../types/state-types";

const applySetProduct = (
  state: ProductStateType,
  { payload }: { payload: Product[] },
): ProductStateType => ({
  products: payload,
  productsLoading: false,
});

const setProductsLoading = (state: ProductStateType): ProductStateType => ({
  ...state,
  productsLoading: true,
});

const initialState: ProductStateType = {
  products: [],
  productsLoading: false,
};

const productReducer = (
  state: ProductStateType = initialState,
  action: ProductAction,
) => {
  switch (action.type) {
    case PRODUCT_SET:
      return applySetProduct(state, action);
    case PRODUCT_LIST_START:
      return setProductsLoading(state);
    default:
      return state;
  }
};

export default productReducer;
